export default __webpack_public_path__ + "static/media/Company.fc13b3b0.png";